import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kredit-start-tilgungsstart"
export default class extends Controller {
	connect() {
		this.handleStartdatumChange = this.handleStartdatumChange.bind(this)
		this.startdatumInput = this.element.querySelector('input[name="kredit[startdatum]"]')
		this.tilgungsstartInput = this.element.querySelector('input[name="kredit[tilgungsstart]"]')
		this.letztesStartdatum = this.startdatumInput?.value || ""

		this.startdatumInput?.addEventListener("change", this.handleStartdatumChange)
	}

	disconnect() {
		this.startdatumInput?.removeEventListener("change", this.handleStartdatumChange)
	}

	handleStartdatumChange({ currentTarget }) {
		if (!this.tilgungsstartInput) {
			this.letztesStartdatum = currentTarget.value
			return
		}

		const neuesStartdatum = currentTarget.value
		const tilgungsstart = this.tilgungsstartInput.value
		const darfSynchronisieren = tilgungsstart === "" || tilgungsstart === this.letztesStartdatum

		if (darfSynchronisieren) {
			this.syncTilgungsstartUi(neuesStartdatum)
		}

		this.letztesStartdatum = neuesStartdatum
	}

	syncTilgungsstartUi(datumString) {
		const [jahr, monat] = datumString.split("-")
		const datumElement = this.tilgungsstartInput.closest('[data-controller~="datum"]')
		const monatInput = datumElement?.querySelector('[data-datum-target="monat"]')
		const jahrInput = datumElement?.querySelector('[data-datum-target="jahr"]')

		if (monatInput) monatInput.value = String(Number(monat))
		if (jahrInput) jahrInput.value = jahr
		monatInput?.dispatchEvent(new Event("change"))

		this.tilgungsstartInput.value = datumString
		this.tilgungsstartInput.dispatchEvent(new Event("change"))
	}
}
